export default "__VITE_ASSET__Bxett3f3__"